export const tabs = [
  { label: 'Home', value: 'home' },
  // { label: 'Files', value: 'files' },
  // { label: 'Shipments', value: 'shipments' },
  // { label: 'Notes', value: 'notes' }
]
